'use client';

import { c as _c } from "react/compiler-runtime";
import { Heading, Price } from '@petsmart-ui/sparky';
import { decodeEntityString } from '@libs/algolia';
import type { Product } from '@libs/common-types';
import { PricePolicyDrawer } from '../PricePolicyDrawer';
import { getPriceDisplay } from '../product-details';
import { ResponsivePicture } from '../ResponsivePicture';
import { useMiniPdpDrawer } from './model/useMiniPdpDrawer';
export function MiniPdpProductInfo(t0) {
  const $ = _c(27);
  const {
    product
  } = t0;
  let t1;
  if ($[0] !== product.media) {
    t1 = product.media.find(_temp);
    $[0] = product.media;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const firstImage = t1;
  let t2;
  if ($[2] !== product.name) {
    t2 = decodeEntityString(product.name);
    $[2] = product.name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const productName = t2;
  let t3;
  if ($[4] !== product) {
    t3 = getPriceDisplay(product);
    $[4] = product;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const priceDisplay = t3;
  const isDrawerOpen = useMiniPdpDrawer(_temp2);
  const close = useMiniPdpDrawer(_temp3);
  let t4;
  if ($[6] !== firstImage || $[7] !== productName) {
    t4 = firstImage && <div className="mini-pdp-drawer__product-image"><ResponsivePicture src={firstImage.url} alt={productName} size={{
        width: 80,
        height: 80
      }} /></div>;
    $[6] = firstImage;
    $[7] = productName;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== productName) {
    t5 = <Heading tagName="h3" className="sparky-u-theme-typography-body" data-testid="mini-pdp-product-name">{productName}</Heading>;
    $[9] = productName;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== priceDisplay.values || $[12] !== priceDisplay.variant) {
    t6 = <Price values={priceDisplay.values} variant={priceDisplay.variant} size="xl" className="mini-pdp-drawer__product-price" data-testid="mini-pdp-product-price" />;
    $[11] = priceDisplay.values;
    $[12] = priceDisplay.variant;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== close || $[15] !== isDrawerOpen || $[16] !== priceDisplay.variant) {
    t7 = priceDisplay.variant === "disabled" && <PricePolicyDrawer showBackButton={true} forceClosed={!isDrawerOpen} onCloseAll={close} />;
    $[14] = close;
    $[15] = isDrawerOpen;
    $[16] = priceDisplay.variant;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <div className="mini-pdp-drawer__price">{t6}{t7}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t5 || $[22] !== t8) {
    t9 = <div className="mini-pdp-drawer__product-content">{t5}{t8}</div>;
    $[21] = t5;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t4 || $[25] !== t9) {
    t10 = <div className="mini-pdp-drawer__product-info">{t4}{t9}</div>;
    $[24] = t4;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}
function _temp3(state_0) {
  return state_0.close;
}
function _temp2(state) {
  return state.isOpen;
}
function _temp(item) {
  return item.type === "image";
}